import React from 'react';

import BlockIcon from '@mui/icons-material/Block';
import { Container } from '@mui/material';

export const PageNotAllowedForUser = (): JSX.Element => {
	return (
		<Container
			component="main"
			maxWidth="md"
			sx={{ display: 'block', justifyContent: 'center', mt: 20, textAlign: 'center' }}
		>
			<BlockIcon sx={{ color: 'red', textAlign: 'center', fontSize: 70 }} />
			<h2>El usuario no tiene permiso apra acceder a esta página</h2>
		</Container>
	);
};
